import { BaseViewStore, HyperlinkCellData } from 'core/stores';
import { observable, action, makeObservable } from 'mobx';
import { FulfillmentOrderStore } from 'modules/order/stores';
import _ from 'lodash';

class FulfillmentOrderItemsExpandListViewStore extends BaseViewStore {
	@observable change = false;
	data = [];
	showActions = false;
	noDataItem = true;

	constructor(rootStore, componentProps) {
		super(rootStore);
		makeObservable(this);
		this.tableData = {
			columns: [
				{
					key: 'name',
					title: 'FULFILLMENTORDERITEMSVIEW.NAME',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'sku',
					title: 'FULFILLMENTORDERITEMSVIEW.SKU',
					dataCell: HyperlinkCellData,
					onClick: dataItem => this.openProductDetailPage(dataItem.productId),
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
				{
					key: 'quantity',
					title: 'FULFILLMENTORDERITEMSVIEW.QUANTITY',
					selected: true,
					width: 200,
					filter: null,
					resizable: false,
					sortable: false,
				},
			],
		};
		this.store = new FulfillmentOrderStore(rootStore);
		this.findFulfillmentOrder(componentProps.dataItem.id);
	}

	@action.bound
	setAsChanged = () => {
		this.change = !this.change;
	};

	@action.bound
	findFulfillmentOrder = async id => {
		this.suspend();
		this.fulfillmentOrder = await this.store.getFulfillmentOrder(id, {
			embed: ['fulfillmentOrderItems', 'fulfillmentOrderItems.product'],
		});

		this.data = _.map(_.groupBy(this.fulfillmentOrder.fulfillmentOrderItems, 'productId'), group => {
			let totalQuantity = 0;
			_.forEach(group, item => (totalQuantity += item.quantity));
			return {
				productId: group[0].productId,
				sku: group[0].sku,
				quantity: totalQuantity,
				name: group[0].product.name,
			};
		});
		this.setAsChanged();
		this.resume();
	};

	openProductDetailPage = id => {
		this.rootStore.routerStore.goTo('master.app.main.product.list.detail', {
			id: id,
		});
	};
}

export default FulfillmentOrderItemsExpandListViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/FulfillmentOrderItemsExpandListViewStore.js